import React, { Component } from 'react';
import styled from 'styled-components';
import { asField } from 'informed';
import Proposition from './Proposition';
import { PlusIcon } from '../Icons';
import i18next from '../../../i18n';
import { environment } from '../../../utils';
import { startOfDay, groupBy } from '../../../calendarUtils';

const { REACT_APP_BACKEND_HTTP_URL } = environment;

const Container = styled.div`
  margin: 10px 0;
`;

const AddButton = styled.div`
  display: flex;
  align-content: end;
  cursor: pointer;

  svg {
    height: 20px;
    width: 20px;
    margin: auto 1rem;
    path {
      fill: ${(p) => p.theme.color.boldText};
    }
  }

  &:hover {
    color: ${(p) => p.theme.color.boldText};
  }
`;

class PropositionPicker extends Component {
  state = { programmes: null };

  componentDidMount() {
    const { isPostSignup } = this.props;
    if (isPostSignup) {
      this.fetchProgrammes();
    }
  }

  fetchProgrammes = async () => {
    try {
      const resp = await fetch(`${REACT_APP_BACKEND_HTTP_URL}/programmes`);
      const data = await resp.json();
      if (!data || !Array.isArray(data)) {
        console.error('Programme data invalid. Data: ', data);
        return;
      }

      data.forEach((program) => {
        program.start = new Date(program.start);
        program.end = new Date(program.end);
      });

      const grouped = groupBy(data, (x) => startOfDay(x.start));
      this.setState({ programmes: grouped });
    } catch (error) {
      console.error(error);
    }
  };

  setPropositionValue = (index) => (newValue) => {
    const { fieldState, fieldApi } = this.props;
    const { setValue } = fieldApi;
    const prev = [...(fieldState.value || [])];
    prev[index] = newValue;
    setValue(prev);
  };

  deleteProposition = (index) => (newValue) => {
    const { fieldState, fieldApi } = this.props;
    const { setValue } = fieldApi;
    const prev = [...(fieldState.value || [])];
    prev.splice(index, 1);
    setValue(prev);
  };

  renderPropositions = () => {
    const { fieldState, isPostSignup } = this.props;
    const { programmes } = this.state;
    const value = fieldState.value || [];

    const rows = value.map((p, i) => (
      <Proposition
        onUpdateValue={this.setPropositionValue(i)}
        onDelete={this.deleteProposition(i)}
        key={i}
        isPostSignup={isPostSignup}
        programmes={programmes}
        {...p}
      />
    ));

    return <div>{rows}</div>;
  };

  onAddProposition = () => {
    const { fieldState, fieldApi } = this.props;
    const { setValue } = fieldApi;
    const oldValue = fieldState.value || [];

    // remove entries without a date (avoid adding multiple empty ones)
    const value = oldValue.filter((p) => p && !!p.date);

    // empty strings instead of nulls to avoid react warnings about controlled/uncontrolled inputs
    setValue([...value, { date: "", startTime: "", endTime: "" }]);
  };

  renderAddButton() {
    return (
      <AddButton onClick={this.onAddProposition}>
        <PlusIcon />
        <span>{i18next.t('signup.propositions.add')}</span>
      </AddButton>
    );
  }

  render() {
    return (
      <Container>
        {this.renderPropositions()}
        {this.renderAddButton()}
      </Container>
    );
  }
}

export default asField(PropositionPicker);
